// OrtoSoft — i18n — English
// Note: legal bodies on /ml intentionally stay in French (official document).

const en = {
  // navigation
  'nav.home': 'OrtoSoft — home',
  'nav.contact': 'Contact',
  'nav.tel': 'Tel.',
  'nav.telShort': 'Tel.',
  'nav.email': 'Email',

  // hero — sheet front
  'hero.kicker': 'Portfolio — OrtoSoft',
  'hero.oAria': 'The OrtoSoft O logo, geometrically constructed',
  'hero.lede':
    'Software designed and built true. Three products, live — inspect the drawings, then tell me about your project.',
  'hero.ctaDrawings': 'See the drawings',
  'hero.ctaContact': 'Contact',
  'note.scale': 'Scale',
  'note.author': 'Author',
  'note.sheets': 'Sheets',
  'note.year': 'Year',

  // sections
  'section.series': 'Series',
  'section.drawings': 'The drawings',
  'section.drafter': 'The drafter',

  // drawings
  'sheet.tab': 'Drawing',
  'sheet.reading': 'reading distance',
  'dist.overview': 'Overview',
  'dist.action': 'In action',
  'dist.hood': 'Under the hood',
  'sheet.visit': 'Visit',
  'sheet.login': 'Log in',
  'sheet.demo': 'Watch the demo',
  'sheet.get': 'Get it',
  'plate.fig': 'Fig.',

  // drawing 01 — cephalometry
  'p01.title': 'Cephalometry',
  'p01.sub': 'Cephalometric analyses and patient follow-up — for the dental practice.',
  'p01.across':
    'A cephalometric analysis and patient follow-up tool, designed with the practices — the 20 cephalometric landmarks are placed automatically by AI in under a second, with treatment tracking: photos, go / no-go at each stage (aligners or brackets).',
  'p01.capTracing': 'Real tracing',
  'p01.capDemo': 'Demo — video',
  'p01.f1k': 'Function',
  'p01.f1v': 'Cephalometric analyses and patient follow-up',
  'p01.f2k': 'Audience',
  'p01.f2v': 'Dental practices and orthodontists',
  'p01.f3k': 'Product',
  'p01.f3v': 'ortho.ortosoft.fr — live',
  'p01.f4k': 'Demonstration',
  'p01.f4v': 'Presentation video (YouTube)',
  'p01.f5k': 'AI tracing',
  'p01.f5v': '20 cephalometric landmarks placed automatically in under a second',
  'p01.f6k': 'Patient follow-up',
  'p01.f6v': 'Patients get a web link to send the photos defined by the doctor’s own protocol — fewer visits, time saved',

  // drawing 02 — simple bookmarks
  'p02.title': 'Simple Bookmarks',
  'p02.sub': 'Bookmarks manager — simple and eco-friendly.',
  'p02.across': 'Find your bookmarks, simply and ecologically. Switch browsers without the import/export hassle — log in from anywhere and find them back in no time.',
  'p02.capLive': 'Live',
  'p02.f1k': 'Function',
  'p02.f1v': 'Browser bookmarks manager',
  'p02.f2k': 'Principle',
  'p02.f2v': 'Simple and eco-friendly — the essentials, nothing more',
  'p02.f3k': 'Product',
  'p02.f3v': 'sb.ortosoft.fr — live',

  'p03.title': 'Doctolib Pro - export agenda',
  'p03.sub': 'Chrome extension — the day’s agenda, exported in one click.',
  'p03.across': 'The day’s counter is shown on pro.doctolib.fr; one click exports the agenda as JSON — local download or POST to the practitioner’s own server.',
  'p03.capPopup': 'On the page — day counter, Export button',
  'p03.capOptions': 'Options — server address (POST) or local download',
  'p03.f1k': 'Function',
  'p03.f1v': 'Chrome extension for pro.doctolib.fr',
  'p03.f2k': 'Export',
  'p03.f2v': 'JSON — local download or POST to your own server',
  'p03.f3k': 'Product',
  'p03.f3v': 'Chrome Web Store',

  // the drafter
  'about.line':
    'Bogdan Scanteie — designer & developer, OrtoSoft. Open to collaborations and freelance projects.',
  'about.tag': 'The right angle: the straight idea, the true tool.',
  'about.write': 'Write',
  'about.call': 'Call',

  // title block (footer)
  'footer.company': 'Company',
  'footer.contact': 'Contact',
  'footer.legal': 'Legal',
  'footer.ref': 'Ref.',
  'footer.cgv': 'Terms',
  'footer.ml': 'Legal notice',

  // legal page
  'ml.tab': 'Legal sheet',
  'ml.title': 'Legal notice',
  'ml.societe': 'Company',
  'ml.cookies': 'Cookies',
  'ml.cgv': 'Terms of sale',
  'ml.host': 'Host',
};

export default en;
